import ShutterbugUserPage from './ShutterbugUserPage';

export default ShutterbugUserPage;
